import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import Toast from "../../helpers/Toast";
import Layout from "../../components/Layout/Layout";
import { IoArrowBackSharp } from "react-icons/io5";
import { Col, Row } from "reactstrap";
import InputComponent from "../../components/InputComponent";
import { SupplierQuotationService } from "../../services/SupplierQuotationService";
import { SupplierQuotationDTO } from "../../models/Quotation/SupplierQuotationDTO";
import { PartsAndServicesQuotationDTO } from "../../models/Quotation/PartsAndServicesQuotationDTO";
import QuotationPartsTable from "../../components/Quotation/QuotationPartsTable";
import ButtonComponent from "../../components/ButtonComponent";
import { Utilities } from "../../helpers/Utilities";
import DetailsQuotationPartsTable from "../../components/Quotation/DetailsQuotationPartsTable";
import { Console } from "console";

export default function DetailsSupplierQuotation() {
    const { id } = useParams<{ id: string; }>();
    const navigate = useNavigate();
    const intl = useIntl()
    const service = new SupplierQuotationService()
    const [supplierQuotation, setsupplierQuotation] = useState<SupplierQuotationDTO>({} as SupplierQuotationDTO);
    const [loading, setLoading] = useState<boolean>(true);
    const openDate = supplierQuotation.openDate ? new Date(supplierQuotation.openDate) : null;
    const formattedOpenDate = openDate ? `${openDate.getDate()}-${openDate.getMonth() + 1}-${openDate.getFullYear()}` : '';
    const closeDate = supplierQuotation.closeDate ? new Date(supplierQuotation.closeDate) : null;
    const formattedCloseDate = closeDate ? `${closeDate.getDate()}-${closeDate.getMonth() + 1}-${closeDate.getFullYear()} ${closeDate.getHours()}:${closeDate.getMinutes().toString().padStart(2, '0')}` : '';
    const [parts, setParts] = useState<PartsAndServicesQuotationDTO[]>([]);
    const [partsAndServices, setPartsAndServices] = useState<PartsAndServicesQuotationDTO[]>([]);
    const [totalValue, setTotalValue] = useState<number>(0);
    const [isEditable, setIsEditable] = useState<boolean>(false);
    const [notes, setNotes] = useState<string>('');

    const getById = async () => {
        setLoading(true);
        try{
        const response = await service.GetById(Number(id));
        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            setLoading(false);
            return;
        }
        console.log(response.obj);
        setsupplierQuotation(response.obj);
        setIsEditable(response.obj.status?.frontendName === "EM_ANALISE" );
        setNotes(response.obj.notes);

        setPartsAndServices(response.obj.partsAndServicesQuotations);
        const parts = response.obj.partsAndServicesQuotations.map(part => ({
            partId: part.partId,
            partName: part.partName,
            quotationId: supplierQuotation.id,
            quantity: part.quantity,
            costPrice: part.costPrice,
            sellingPrice: part.sellingPrice,
            totalSellingPrice: part.quantity * part.sellingPrice
        }));

        setParts(parts);
        handlePartsChange(parts);
    }catch (e){
        Toast.Show("error", "Erro inesperado ao carregar os dados");
    }finally{
        setLoading(false);
    }
    }

    useEffect(() => {
        setTotalValue(calculateTotalValue(parts));
    }, [parts])

    const handleSubmit = async () => {
        const partsAndServicesQuotationDTO: PartsAndServicesQuotationDTO[] = parts.map(part => ({
            partName: part.partName,
            partId: String(part.partId),
            quotationId: supplierQuotation.id,
            quantity: part.quantity,
            sellingPrice: part.sellingPrice,
            costPrice: part.costPrice,
            totalSellingPrice: Utilities.calculateTotalPrice(part.quantity, part.sellingPrice)
        }));

        if(partsAndServicesQuotationDTO.length === 0) {
            Toast.Show('error', intl.formatMessage({ id: "Screens.SupplierQuotation.Parts.Info.MissingArticles" }));
            return;
        }

        const quotationEditDTO = {
            partsAndServices: partsAndServicesQuotationDTO,
            notes: notes 
        };

        try {
            setLoading(true);
            const response = await service.Edit(supplierQuotation.id, quotationEditDTO);
            if (response.success === false || response.obj === null) {
                Toast.Show("error", response.message);
                setLoading(false);
                return;
            }
    
            Toast.Show("success", intl.formatMessage({ id: "Screens.SupplierQuotation.Info.Edit" }));
            navigate("/supplierQuotations");
        } catch (error) {
            Toast.Show("error", intl.formatMessage({ id: "Screens.SupplierQuotation.Parts.Info.Error" }));
        } finally {
            setLoading(false); 
        }
    };

    const calculateTotalValue = (parts: PartsAndServicesQuotationDTO[]) => {
        setParts(parts);
    
        let sum = 0;
        parts.forEach(part => {
          sum += Utilities.calculateTotalPrice(part.quantity,part.costPrice);
        });
        return sum;
      };


    const handlePartsChange = (parts: PartsAndServicesQuotationDTO[]) => {
        setParts(parts);
        setTotalValue(calculateTotalValue(parts));
      }


    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <span className="pageTitle">
                        <Row className="pageHeader" style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                            <Col xl={4} lg={4} md={12} sm={12} xs={12} style={{ display: "flex", margin: "0px" }}>
                                {" "}
                                <IoArrowBackSharp className="pageTitleBackIcon" onClick={() => navigate(-1)} />
                                <FormattedMessage id="Screens.SupplierQuotation.Title" />:
                            </Col>
                            <Col
                                xl={8}
                                lg={8}
                                md={12}
                                sm={12}
                                xs={12}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "end",
                                }}
                            >
                            {supplierQuotation?.status?.frontendName ? (
                                <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                    {intl.formatMessage({ id: "Screens.ClientQuotation.Header.Status" })}
                                    <span style={{ textTransform: "uppercase" }}>{supplierQuotation.status.frontendName}</span>
                                </span>
                            ) : (
                                <span style={{ fontWeight: "bold", fontSize: "14px", marginRight: "2%" }}>
                                    {intl.formatMessage({ id: "Screens.ClientQuotation.Header.Status" })}
                                    <span style={{ textTransform: "uppercase" }}></span>
                                </span>
                            )}
                            </Col>
                        </Row>
                    </span>
                </div>
                <div className="pageBody">
                    {loading ? (
                        <div>Loading...</div>
                    ) : (
                        <>
                            <Row style={{ margin: "0px", padding: "0px" }}>
                                <InputComponent
                                    xl={2.5}
                                    lg={2.5}
                                    md={3}
                                    sm={6}
                                    xs={6}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={supplierQuotation.supplier ? supplierQuotation.supplier.name : ''}
                                    label={intl.formatMessage({
                                        id: "Screens.Quotation.Info.Supplier",
                                    })}
                                    readOnly={true}
                                />
                                <InputComponent
                                    xl={2}
                                    lg={2}
                                    md={3}
                                    sm={6}
                                    xs={6}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={supplierQuotation.assistance ? `${supplierQuotation.assistance.erpDocType} ${supplierQuotation.assistance.erpSerie} ${supplierQuotation.assistance.erpNumDoc}` : ''}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.Assistance",
                                    })}
                                    readOnly={true}
                                />
                                <InputComponent
                                    xl={2}
                                    lg={2}
                                    md={3}
                                    sm={6}
                                    xs={6}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={supplierQuotation.clientQuotationId ? supplierQuotation.clientQuotationId.toString() : ''}
                                    label={intl.formatMessage({
                                        id: "Screens.Quotation.Info.ClientQuotation",
                                    })}
                                    readOnly={true}
                                />
                                <InputComponent
                                    xl={2}
                                    lg={2}
                                    md={3}
                                    sm={6}
                                    xs={6}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={formattedOpenDate}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.OpenDate",
                                    })}
                                    readOnly={true}
                                />
                                <InputComponent
                                    xl={2}
                                    lg={2}
                                    md={3}
                                    sm={6}
                                    xs={6}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={formattedCloseDate !== '1-1-1 0:00' ? formattedCloseDate : null}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.CloseDate",
                                    })}
                                    readOnly={true}
                                />
                            </Row>
                            <Row style={{ margin: "0px", padding: "0px" }}>
                                <InputComponent
                                    xl={8}
                                    lg={8}
                                    md={10}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={supplierQuotation.description}
                                    label={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Info.Description",
                                    })}
                                    readOnly={true}
                                />
                            </Row>
                            <Row style={{ margin: "5px", padding: "0px" }}>
                                    <DetailsQuotationPartsTable isEditable={isEditable} reloadParts={true} goToPage={0} currentPage={0} isComplete={false} onPartsChange={handlePartsChange} initialParts={parts} quotationType={supplierQuotation.quotationType} id={Number(id)}/>
                                </Row>
                            <Row style={{ margin: "0px", padding: "0px" }}>
                                {supplierQuotation.status.frontendName === 'EM_ANALISE' ? (
                                    <InputComponent
                                        xl={4}
                                        lg={4}
                                        md={5}
                                        sm={12}
                                        xs={12}
                                        style={{ width: "100%" }}
                                        type={"text"}
                                        value={notes}
                                        label={intl.formatMessage({
                                            id: "Screens.ClientQuotation.Info.Notes",
                                        })}
                                        onChange={(text: string) => setNotes(text)}
                                        readOnly={false}
                                    />
                                ) : (
                                    <InputComponent
                                        xl={4}
                                        lg={4}
                                        md={5}
                                        sm={12}
                                        xs={12}
                                        style={{ width: "100%" }}
                                        type={"text"}
                                        value={notes}
                                        label={intl.formatMessage({
                                            id: "Screens.ClientQuotation.Info.Notes",
                                        })}
                                        readOnly={true}
                                    />
                                )
                                }

                                <InputComponent
                                    xl={4}
                                    lg={4}
                                    md={5}
                                    sm={12}
                                    xs={12}
                                    style={{ width: "100%" }}
                                    type={"text"}
                                    value={totalValue.toString()}
                                    label={intl.formatMessage({
                                        id: "Screens.SupplierQuotation.Table.Column5",
                                    })}
                                    readOnly={true}

                                />

                            </Row>
                            <Row style={{ margin: "0px", padding: "8px" }}>
                                <Col>
                                {isEditable &&
                                    <ButtonComponent
                                    disabled={loading}
                                    loading={loading}
                                    text={intl.formatMessage({
                                        id: "Screens.ClientQuotation.Button.Create",
                                    })}
                                    onClick={handleSubmit}
                                    />
                                }
                                </Col>
                            </Row>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}